import styled from "styled-components";

export const ContactStyles = styled.section.attrs(props => ({
    id: props.id,
}))`
    padding: 8rem 0 8rem;
    min-height: 100vh;

    & .contact__form {
        flex: 0 0 100%;
        max-width: 100%;

        & .w-50 {
            padding: 0 1.5rem;
            flex: 0 0 50%;
            max-width: 50%;

            @media screen and (max-width: 1000px) {
                flex: 0 0 80%;
                max-width: 80%;
                margin: auto;
            }

            & .input__group {
                margin: 0 0 25px;
                transition: all .3s ease;
                border-radius: 30px;
                position: relative;

                &::after {
                    border-radius: 30px;
                }

                & .input__control {
                    height: 45px;
                    display: block;
                    width: 100%;
                    border: none;
                    border-radius: 30px;
                    background-color: transparent;
                    font-size: 1.6rem;
                    padding: 0 1.5rem;
                    color: var(--color-text2);
                }

                & .error-message {
                    width: 100%;
                    position: absolute;
                    top: 45px;
                    font-size: 1.5rem;
                    color: red;
                }

                & textarea ~ p {
                    top: 190px !important;
                }

                & textarea.input__control {
                    height: 184px;
                    padding-top: 15px;
                    resize: none;
                }
            }
        }

        & .success, & .failed {
            position: absolute;
            font-size: 3rem;
            color: var(--color-success);
            width: 100%;
            text-align: center;

            @media screen and (max-width: 500px) {
                top: 5rem;
            }
        }

        & .failed {
            color: var(--color-danger);
        }

        & .submit__btn {
            flex: 0 0 100%;
            max-width: 100%;
            text-align: right;
            padding: 0 1.5rem;

            @media screen and (max-width: 1000px) {
                flex: 0 0 80%;
                max-width: 80%;
                margin: auto;
            }
        }
    }

    & .arrow-box {
        flex: 0 0 100%;
        max-width: 100%;
        text-align: center;
        margin-top: 5rem;

        & .btn-link {
            font-size: 6rem;
        }
    }

`;